import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '../assets/images/phone.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "start" }, null, -1)
const _hoisted_3 = { class: "menu menu-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "menu-list menu-visibility" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "Accueil", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "Dénoncer", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "Suivre ma dénonciation", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item" }, "FAQ", -1)
const _hoisted_11 = { class: "contact_phone" }
const _hoisted_12 = {
  style: {"color":"white"},
  width: "40",
  height: "40",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M3 18v-2h18v2Zm0-5v-2h18v2Zm0-5V6h18v2Z"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  style: {"color":"white"},
  width: "40",
  height: "40",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6Z"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"contact\"><img src=\"" + _imports_1 + "\"><div class=\"communicated\"> Communiquez <br> avec nous </div><div class=\"tenten\">155</div><div class=\"call_free\">(Appel gratuit)</div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "logo",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.homepage && _ctx.homepage(...args)))
        }, _hoisted_5),
        _createElementVNode("nav", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectmenu('accueil')))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/about" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["menu-item", _ctx.a_about ? 'active' : 'desactive']),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectmenu('about')))
              }, " A propos ", 2)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/report",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectmenu('report')))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/follow",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectmenu('follow')))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/faq",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectmenu('faq')))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mobileMenu('display'))),
            style: _normalizeStyle(_ctx.affichage == 'true' ? 'display:block' : 'display:none' )
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
          ], 4),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mobileMenu('close'))),
            style: _normalizeStyle(_ctx.affichage == 'false' ? 'display:block' : 'display:none' )
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
          ], 4)
        ]),
        _hoisted_18
      ])
    ])
  ]))
}